/* eslint-disable import/prefer-default-export */
import api from 'config/api';

export const buscarConstantes = () => api.get('/configuracoes/constantes');
